import { Redirect } from 'react-router-dom';
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import config, { authGraphqlHeaders } from './index';

export const LEGACY_PORTAL_BLOCKED_MESSAGE_KEY = 'legacyPortalBlockedMessage';

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    const legacyBlockedError = graphQLErrors.find(
      ({ extensions }) => extensions?.code === 'LEGACY_PORTAL_BLOCKED'
    );

    // Rede bloqueou o legado: encerra a sessão e leva ao login com a mensagem
    if (legacyBlockedError) {
      sessionStorage.setItem(
        LEGACY_PORTAL_BLOCKED_MESSAGE_KEY,
        legacyBlockedError.message
      );
      localStorage.removeItem('user');
      window.location.replace('/login');
      return;
    }

    const forbiddenError = graphQLErrors.find(
      ({ extensions }) => extensions.code === 'FORBIDDEN'
    );

    if (forbiddenError) {
      <Redirect to='/logout' />;
    }
  }
});

const httpLink = createHttpLink({
  uri: config.URL_API
});

const authLink = setContext((_, { headers }) => {
  return authGraphqlHeaders(headers);
});

const client = new ApolloClient({
  uri: config.URL_API,
  link: from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache()
});

export default client;
